export var globalState = {};
export var setCurrentState = function (state) {
    globalState = state;
};
export var previousState = {};
export var setPreviousState = function (state) {
    previousState = state;
};
export var subscribers = [];
//# sourceMappingURL=stateContainer.js.map